import { QuestionRequiredPrepMilli } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { usePlanRequiredPrepMillisecond } from "./hooks";

export const QuestionPlanRequiredPrepMillisecond = () => {
	const {
		requiredPrepMillisecondBeforeDate,
		onSetRequiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeDateOptions,

		requiredPrepMillisecondBeforeHour,
		onSetRequiredPrepMillisecondBeforeHour,
		requiredPrepMillisecondBeforeHourOptions,

		isEdited,
		hasError,
	} = usePlanRequiredPrepMillisecond();

	return (
		<QuestionRequiredPrepMilli
			isEdited={isEdited}
			hasError={hasError}
			requiredPrepMillisecondBeforeDate={requiredPrepMillisecondBeforeDate}
			requiredPrepMillisecondBeforeDateOptions={requiredPrepMillisecondBeforeDateOptions}
			onSetRequiredPrepMillisecondBeforeDate={onSetRequiredPrepMillisecondBeforeDate}
			requiredPrepMillisecondBeforeHour={requiredPrepMillisecondBeforeHour}
			requiredPrepMillisecondBeforeHourOptions={requiredPrepMillisecondBeforeHourOptions}
			onSetRequiredPrepMillisecondBeforeHour={onSetRequiredPrepMillisecondBeforeHour}
		/>
	);
};

QuestionPlanRequiredPrepMillisecond.displayName = "QuestionPlanRequiredPrepMillisecond";
